import { ConnectionStatus } from 'app/constants/connectionStatus'

export const getConnectionStatusText = (status: ConnectionStatus): string => {
  let text = '-'

  switch (status) {
    case ConnectionStatus.CONNECTED:
      text = 'connectionStatus.connected'
      break
    case ConnectionStatus.NOT_CONNECTED:
      text = 'connectionStatus.not-connected'
      break
    case ConnectionStatus.PROCESSING:
      text = 'connectionStatus.processing'
      break
    case ConnectionStatus.CREATING:
      text = 'connectionStatus.creating'
      break
    default:
      text = 'connectionStatus.unknown'
      break
  }

  return text
}
